import { Button, Group, Stack, Text } from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconLayersSelected } from "@tabler/icons-react";
import { deleteFromBlacklist } from "../../../../../api/ContactAPI";
import { notifications } from "@mantine/notifications";
import CreatableBlacklistSelector from "../../../../../components/Selectors/CreatableBlacklistSelector";
import BlacklistSelector from "../../../../../components/Selectors/BlacklistSelector";

const UndoubleBlacklist = ({ id, handleClose, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const [lists, setLists] = useState([]);

  const [loading, setLoading] = useState(false);

  const main = async () => {
    setLoading(true);

    try {
      const promises = lists.map(list => deleteFromBlacklist({
        id,
        blacklist_id: list?.id,
      }));
      await Promise.all(promises).finally(() => setLoading(false));
      onFinish?.();
    } catch (error) {
      notifications.show({
        title: lang.contact_lists.undouble.error,
        message: error?.response?.data?.message || lang.contact_lists.undouble.error_desc,
        color: "red",
      });
    }
    handleClose();
  };

  return (
    <Stack w={300}>
      <Stack gap={16}>
        <Text>{lang.contact_lists.undouble.text_blacklist}</Text>

        <BlacklistSelector
          values={lists.map(x => x.id)}
          onChange={setLists}
          placeholder={lang.targeting_linkedin_google.select_blacklist}
          w={"100%"}
          styles={{ label: { fontSize: 13 } }}
          size="sm"
          comboboxProps={{
            zIndex: 1700,
            withinPortal: false,
          }}
          withCreatedOn={false}
          dropdownHeight={400}
        />
      </Stack>
      <Group justify="end">
        <Button
          leftSection={<IconLayersSelected size={16} />}
          onClick={main}
          loading={loading}
          color="red"
          disabled={!lists.length}
        >
          {lang.contact_lists.undouble.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default UndoubleBlacklist;
